import styled from "@emotion/styled"
import { SetStateAction } from "jotai"
import { Dispatch, useEffect, useMemo, useState } from "react"
import DepositBlockTitle from "../components/DepositBlockTitle"
import ValueInput from "./ValueInput"
import Svg from "@/components/base/Svg"
import PagcorRequirements from "./PagcorRequirements"
import { computed } from "@preact/signals"
import AppSignals from "@/features_signal/app"

const Container = styled.div`
    border-radius: 10rem;
    background-color: #ffffff;
    padding: 12rem;
    padding-bottom: 12rem;
    margin: 12rem;
`

interface MoneyProps {
    isMaya?: boolean
    isActive?: boolean
}
const MoneyNumList = styled.div<MoneyProps>`
    display: flex;
    flex-wrap: ${(props) => (props.isMaya ? "wrap" : "nowrap")};
    overflow-x: auto;
    gap: ${(props) => (props.isMaya ? "6rem" : "8rem;")};
    white-space: nowrap;
    padding-top: 16rem;
    padding-bottom: ${(props) => (props.isMaya ? "20rem" : "0;")};
    &::-webkit-scrollbar {
        height: 0;
        background: transparent;
        opacity: 0; /* 默认隐藏 */
    }
`
const MoneyBlock = styled.div<MoneyProps>`
    flex: 0 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    width: ${(props) => (props.isMaya ? "105rem" : "78rem")};
    height: ${(props) => (props.isMaya ? "48rem" : "40rem")};
    line-height: ${(props) => (props.isMaya ? "48rem" : "40rem")};
    text-align: center;
    border-radius: 6rem;
    background: ${(props) => (props.isActive ? "#ffffff" : "#f2f3f5")};
    color: ${(props) => (props.isActive ? "#054BF0" : "#40444f")};
    border: ${(props) => (props.isActive ? "1rem solid#054BF0" : "none")};
    cursor: pointer;
    font-weight: 400;
    font-size: 16rem;
`

// eslint-disable-next-line react-refresh/only-export-components
export function formatThousandsIntl(num: string): string {
    try {
        return new Intl.NumberFormat("en-US").format(parseFloat(num))
    } catch {
        return num
    }
}

export default function IntInput({
    setAmount,
    amount,
    errorMsg,
    amountLimit = [],
    min = "",
    max = "",
    pagcorTip = "",
}: {
    errorMsg: string
    amount: string
    min: string
    max: string
    amountLimit?: string[]
    pagcorTip?: string
    setAmount: Dispatch<SetStateAction<string>>
}) {
    const [val, setVal] = useState<string>("")
    const isMayamini = computed(() => {
        return AppSignals.isMayaminiUser()
    })
    useEffect(() => {
        setVal(val.replace(/[^\d]/g, ""))
    }, [val])

    useEffect(() => {
        setAmount(val)
    }, [setAmount, val])

    return (
        <Container>
            <DepositBlockTitle>Deposit Amount</DepositBlockTitle>
            {/* 当合规开关开启，【Deposit】弹窗中的Payment Methods为“GCash”和“Maya”方式下，Deposit Amount卡片种显示最小充值金额提示： */}
            <PagcorRequirements text={pagcorTip} />
            {isMayamini.value ? (
                <MoneyNumList isMaya={isMayamini.value}>
                    {amountLimit?.map((moneyItem, index) => (
                        <MoneyBlock
                            key={`${index}_fast_sel_amount`}
                            isActive={amount.toString() === moneyItem}
                            isMaya={isMayamini.value}
                            onClick={() => {
                                setVal(moneyItem)
                            }}
                        >
                            {formatThousandsIntl(moneyItem)}
                        </MoneyBlock>
                    ))}
                </MoneyNumList>
            ) : (
                ""
            )}
            <ValueInput
                placeholder={`Enter Amount: ${formatThousandsIntl(min)}-${formatThousandsIntl(
                    max,
                )}`}
                value={amount}
                onChange={(v) => {
                    setVal(v)
                }}
                errorMsg={errorMsg}
                maxLength={20}
                prefix={
                    <div
                        css={`
                            padding-right: 13rem;
                            display: flex;
                            align-items: center;
                            justify-content: center;
                        `}
                    >
                        <Svg src="pages/UserCenterPage/deposit/peso.svg" />
                    </div>
                }
            />
            {amountLimit.length > 0 && !isMayamini.value ? (
                <MoneyNumList isMaya={isMayamini.value}>
                    {amountLimit?.map((moneyItem, index) => (
                        <MoneyBlock
                            key={`${index}_fast_sel_amount`}
                            isActive={amount.toString() === moneyItem}
                            isMaya={isMayamini.value}
                            onClick={() => {
                                setVal(moneyItem)
                            }}
                        >
                            {formatThousandsIntl(moneyItem)}
                        </MoneyBlock>
                    ))}
                </MoneyNumList>
            ) : null}
        </Container>
    )
}
